import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { TokenStorageService } from './token.service';
@Injectable({
  providedIn: 'root'
})
export class EcommerceService {
  constructor(public http: HttpClient, private tokenStorageService: TokenStorageService) { }
  async getAllProducts(obj) {
    let body = {
      target: "getProductColl",
      query: obj,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getProductCollRegex(obj) {
    let body = {
      target: "getProductcollRegex",
      query: obj,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getProductsCount(obj) {
    let body = {
      target: "getProductCollCount",
      query: obj,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getMangoExportsResidueCount(obj) {
    let body = {
      target: "getMangoExportsResidueCount",
      query: obj,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async getMangoExportsResidueData(obj) {
    let body = {
      target: "getMangoExportsResidueData",
      query: obj,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceReadGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async saveSingleProduct(Product) {
    let body = {
      target: "saveProductColl",
      source: Product,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
  async updateProductData(product) {
    let obj = {
      productId: product.productId,
      group: product.group
    }
    let body = {
      target: "updateProductColl",
      source: product,
      query: obj,
      lKey: "Utilities"
    }
    return new Promise((resolve, reject) => {
      this.http.post(environment.ecommerceWriteGateway, body, this.tokenStorageService.createHttpOptions()).subscribe(result => {
        resolve(result)
      }, reject);
    })
  }
}
